import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'orgs.org_levels_org_specific_labels'

const state = {
  ...makeTableCommonState()
}

const getters = {
  pageTitle: () => 'Org levels',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: 0,
      fetch: 0,
      update: 0,
      delete: 0,
      downloadList: -1,
      uploadList: -1
    }
  },

  controllers: () => {
    return {
      get create () { return remoteEntityName + '_create' }, // override controller names if they are different
      get fetch () { return remoteEntityName + '_fetch' },
      get update () { return remoteEntityName + '_update' },
      get delete () { return remoteEntityName + '_delete' }
    }
  },

  columns: (state, getters, rootState) => {
    return [
      { name: 'id', label: 'Org level', field: 'id', align: 'right' },
      { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true }
    ]
  },

  remoteEntityName: () => remoteEntityName,

  ...makeTableCommonGetters({ remoteEntityName })
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
